import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; //useNavigate
import swal from "sweetalert";
import Modal from "./childComponents/popups/Modal";
import Loading from "./childComponents/appComponents/Loading";
import InputField from "./childComponents/inputComponents/InputField";
import SelectField from "./childComponents/inputComponents/SelectField";
import { MdContentPasteSearch } from "react-icons/md";

let allRecordimage;
const Register = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const BUTTON_NAME = "Search Register"; // Submit Button Name

  const [allRecords, setAllRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [displayMessages, setDisplayMessages] = useState("");

  //Fetches all Form Data
  const [formData, setFormData] = useState({
    input: {
      startDate: null,
      endDate: null,
    },
    select: {
      inStatus: null,
      outStatus: null,
      location: null,
    },
  });

  const [options, setOptions] = useState({
    inStatus: [],
    outStatus: [],
    location: [],
  });

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  // Reload Page
  const [reloadState, setReloadState] = useState({
    btnLoading: BUTTON_NAME,
    loading: true,
  });

  // Open Dialogue Box
  const [dialogueState, setDialogueState] = useState({
    modalType: false,
    modalTitle: null,
    trigger: false,
    editpost: null,
    searchDates: null,
    searchScript: null,
  });

  // Fetch the first day of the current month
  function getFirstDay() {
    const firstDay = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1,
    );
    return firstDay.toISOString().split("T")[0];
  }

  // Fetch the Current Date
  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  useEffect(() => {
    (async () => await fetchRegistryData())();
  }, [dialogueState.editpost]);

  //Query constructor
  const queryConstructorString = () => {
    let query = "?";
    let messages = "";
    const initializeSearchDate = {};

    // Helper function to handle query string updates
    const addToQuery = (condition, queryKey, value, label) => {
      if (condition) {
        query += `${queryKey}[eq]=${value}&`;
        messages += `${label.toUpperCase()}: ${value} | `;
      }
    };

    const { input, select } = formData;
    // Add query parameters dynamically
    addToQuery(
      true,
      "fileNumber",
      localStorage.getItem("NumberType"),
      "FileNo.",
    );

    addToQuery(select.inStatus, "inStatus", select.inStatus, "Arrival");

    addToQuery(select.outStatus, "outStatus", select.outStatus, "Departure");

    addToQuery(select.location, "location", select.location, "Location");

    if (input.startDate) {
      query += `date[gte]=${input.startDate}&`;
      messages += `START DATE: ${input.startDate} | `;
      initializeSearchDate.startDate = input.startDate;
    }

    if (input.endDate) {
      query += `date[lte]=${input.endDate}&`;
      messages += `END DATE: ${input.endDate} | `;
      initializeSearchDate.endDate = input.endDate;
    }

    if (query === "?") {
      query = `?date[eq]=${getCurrentDate()}`;
      messages = "ALL STAFF REGISTER";
      initializeSearchDate.startDate = getFirstDay();
      initializeSearchDate.endDate = getCurrentDate();
    } else {
      query += "name[ne]=" + null;
    }

    return { query, messages, initializeSearchDate };
  };

  // Fetch All Registry Records
  const fetchRegistryData = async () => {
    const { query, messages, initializeSearchDate } = queryConstructorString();

    // Display Current Search Request Parameters as a Message
    setDisplayMessages(messages);

    // Store a sample of Current Search Request Parameters for Dialogue Box
    setDialogueState((prev) => ({
      ...prev,
      searchScript: query,
    }));

    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(`${BASE_URL}registration_page${query}`),
        axios.get(`${BASE_URL}inputlocation?status[eq]=Active`),
        axios.get(
          `${BASE_URL}inputcomponents?type[eq]=inOutStatus&activeStatus[eq]=Active`,
        ),
      ]);

      const [registerData, locationData, inOutStatusData] = responses;

      if (registerData.data.status === 200) {
        if (registerData.data.allData.length === 0) {
          swal(
            "Oops!",
            "Sorry! we did not find any information in the register",
            "warning",
          );
        } else {
          setDialogueState((prev) => ({
            ...prev,
            searchDates: initializeSearchDate,
          }));
          setAllRecords(registerData.data.allData);
          setFilteredRecords(registerData.data.allData);
        }

        setReloadState({
          btnLoading: BUTTON_NAME,
          loading: false,
        });
      }

      // populate the select menu
      const populateSelect = (colume, columeObject, columeName, values1) => {
        function extractColumn(arr, column, value) {
          return arr.map((x) => ({ item: x[column], values: x[value] }));
        }

        if (columeObject.data.status === 200) {
          return setOptions((prev) => ({
            ...prev,
            [colume]: extractColumn(
              columeObject.data.allData,
              columeName,
              values1,
            ),
          }));
        } else if (columeObject.data.status === 500) {
          swal("Oops!", columeObject.data.message, "error");
        }
      };

      populateSelect("location", locationData, "location", "location");
      populateSelect(
        "inStatus",
        inOutStatusData,
        "productCategory",
        "productCategory",
      );
      populateSelect(
        "outStatus",
        inOutStatusData,
        "productCategory",
        "productCategory",
      );
    } catch (error) {
      swal("Error", "Error fetching Registry Data", "error");
      console.log("Error fetching Registry Data:", error);
    }
  };

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const newRecords = allRecords.slice(firstIndex, lastIndex);
  const npage = Math.ceil(allRecords.length / recordsPerPage);
  const number = [...Array(npage + 1).keys()].slice(1);

  // Search
  async function searchData(event) {
    event.preventDefault();
    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
    }));
    fetchRegistryData();
  }

  const handleFilter = (event) => {
    let text = event.target.value;

    let newData = filteredRecords.filter(
      (row) =>
        row.name.toLowerCase().includes(text.toLowerCase()) ||
        row.fileNumber.toLowerCase().includes(text.toLowerCase()) ||
        row.checkIn.toLowerCase().includes(text.toLowerCase()) ||
        row.checkOut.toLowerCase().includes(text.toLowerCase()) ||
        row.shift.toLowerCase().includes(text.toLowerCase()),
    );
    if (event) {
      setAllRecords(newData.length > 0 ? newData : allRecords);
    }
  };

  // Open Dialogue Box for Printing Registry
  async function printRegister() {
    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalRegisterDetails",
      modalTitle: "REGESTRY DETAILS",
      trigger: true,
      editpost: allRecords,
    }));

    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
    }));
  }

  // Clean the Form
  const formCleanner = () => {
    setDialogueState((prev) => ({
      ...prev,
      modalType: false,
      modalTitle: null,
      trigger: false,
      editpost: null,
      searchDates: null,
      searchScript: null,
    }));

    fetchRegistryData();
  };

  if (reloadState.loading) {
    return <Loading message01={"Loading..."} />;
  }

  return (
    <>
      {/* modal Type, Title of the Modal Box, triger the modal, convay all the data inputs to be edithed to child */}
      <Modal
        modalType={dialogueState.modalType}
        titles={dialogueState.modalTitle}
        trigger={dialogueState.trigger}
        editpost={dialogueState.editpost}
        searchDate={dialogueState.searchDates}
        formCleanner={formCleanner}
        searchScript={dialogueState.searchScript}
      />

      <div className="container-lg-fluid m-3">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div className="card-header text-white bg-secondary p-3">
                <i className="fa fa-search"></i> SEARCH REGISTER
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <InputField
                    label="Start Date"
                    name="startDate"
                    size="3"
                    placeholder="Please Select Start Date"
                    required=""
                    value={formData.input.startDate}
                    type="date"
                    onChange={updateFormData}
                    icon="fa fa-calendar-check-o"
                  />

                  <InputField
                    label="End Date"
                    name="endDate"
                    size="3"
                    placeholder="Please Select End Date"
                    required=""
                    value={formData.input.endDate}
                    type="date"
                    onChange={updateFormData}
                    icon="fa fa-calendar-check-o"
                  />

                  <SelectField
                    label="Arrival"
                    name="inStatus"
                    size="3"
                    placeholder="Please Select Arrival Status"
                    required=""
                    value={formData.select.inStatus}
                    options={options.inStatus}
                    switchOptions={1}
                    onChange={updateFormData}
                    icon="fa fa-plane"
                  />

                  <SelectField
                    label="Departure"
                    name="outStatus"
                    size="3"
                    placeholder="Please Select Departure Status"
                    required=""
                    value={formData.select.outStatus}
                    options={options.outStatus}
                    switchOptions={1}
                    onChange={updateFormData}
                    icon="fa fa-plane"
                  />

                  <SelectField
                    label="Location"
                    name="location"
                    size="3"
                    placeholder="Please Select An Office Location"
                    required=""
                    value={formData.select.location}
                    options={options.location}
                    switchOptions={1}
                    onChange={updateFormData}
                    icon="fa fa-location-arrow"
                  />

                  <div className="col-lg-6">
                    <div className="row form-group mt-3">
                      <div className="col-lg-4">
                        <Link
                          className="btn btn-iceberg col-12 mt-4"
                          onClick={softreload}
                          to="/user/register"
                        >
                          <i className="fa fa-refresh"></i>
                        </Link>
                      </div>
                      <div className="col-lg-4">
                        <button
                          className="btn btn-iceberg col-12 mt-4"
                          onClick={searchData}
                        >
                          <div className=" d-flex justify-content-center">
                            <i className="fa fa-search pt-1 pe-2"></i>
                            {reloadState.btnLoading}
                          </div>
                        </button>
                      </div>

                      <div className="col-lg-4">
                        <button
                          className="btn btn-primary col-12 mt-4"
                          onClick={printRegister}
                          data-toggle="modal"
                          data-target="#exampleModal"
                        >
                          <div className="d-flex justify-content-center">
                            <i className="fa fa-print pt-1 pe-2"></i>
                            Print Document
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-lg-fluid m-3">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div className="card-header text-white bg-secondary p-3">
                <MdContentPasteSearch style={{ fontSize: "20px" }} /> ALL STAFF
                <span className="float-end me-3">{displayMessages}</span>
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <div>
                    <div style={{ display: "flex", float: "right" }}>
                      <input
                        type="text"
                        name="searchData"
                        placeholder="...Employee"
                        style={{ padding: "5px 7px" }}
                        onChange={handleFilter}
                      />
                    </div>
                  </div>
                  <div style={{ width: "100%", overflowX: "scroll" }}>
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col" style={{ width: "5%" }}>
                            Select
                          </th>
                          {[
                            "Name",
                            "Image",
                            "Department",
                            "Shift",
                            "Location",
                            "Notes",
                            "Supervisor",
                            "Date",
                            "Check In",
                            "Check Out",
                            "Distance",
                          ].map((items, index) => (
                            <>
                              <th key={index} scope="col">
                                {items}
                              </th>
                            </>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {newRecords.map((allRecord, index) => {
                          if (
                            allRecord.imageIn === null ||
                            allRecord.imageIn === "null"
                          ) {
                            allRecordimage =
                              "upload/attendance_passports/1673523387.jpg";
                          } else {
                            allRecordimage = allRecord.imageIn;
                          }

                          return (
                            <tr key={index}>
                              <th scope="row">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  name={allRecord.id}
                                />
                              </th>

                              <td>
                                {allRecord.name}
                                <br />
                                <em style={{ color: "red" }}>
                                  Staff No.: {allRecord.fileNumber}
                                </em>
                              </td>
                              <td>
                                <Link
                                  to={BACKEND_URL + allRecordimage}
                                  target="_blank"
                                >
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    src={BACKEND_URL + allRecordimage}
                                    alt={allRecordimage || "Image"}
                                    width={60}
                                    height={70}
                                  />
                                </Link>
                              </td>
                              <td>{allRecord.department}</td>
                              <td>{allRecord.shift}</td>
                              <td>{allRecord.location}</td>
                              <td>{allRecord.message}</td>
                              <td>{allRecord.adminName}</td>
                              <td>{allRecord.date}</td>
                              <td>{allRecord.checkIn}</td>
                              <td>{allRecord.checkOut}</td>
                              <td>{allRecord.totalDistance} Meter(s)</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  <nav>
                    <ul className="pagination">
                      <li className="page-item">
                        <Link to="#" className="page-link" onClick={prePage}>
                          Prev
                        </Link>
                      </li>

                      {number.map((n, i) => (
                        <li
                          className={`page-item ${
                            currentPage === n ? "active" : ""
                          }`}
                          key={i}
                        >
                          <Link
                            to="#"
                            className="page-link"
                            onClick={() => changeCPage(n)}
                          >
                            {n}
                          </Link>
                        </li>
                      ))}

                      <li className="page-item">
                        <Link to="#" className="page-link" onClick={nextPage}>
                          Next
                        </Link>
                      </li>
                      <li className="page-item ps-3 pe-3 pt-1 bg-primary text-white">
                        Total Count: {allRecords.length}
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  function softreload() {
    window.location.reload();
  }

  /* Pagination*/
  function prePage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    if (currentPage !== firstIndex) {
      setCurrentPage(id);
    }
  }
  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  }
  /* End of Pagination*/
};

export default Register;
